module.exports = __webpack_public_path__ + "media/images/blog-thumb-01-f33d8c7e93661b687a586f63c85f748d.jpg";